var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3387 14.0884C26.3387 20.8539 20.8541 26.3384 14.0887 26.3384C7.32317 26.3384 1.83865 20.8539 1.83865 14.0884C1.83865 7.32289 7.32317 1.83838 14.0887 1.83838C20.8541 1.83838 26.3387 7.32289 26.3387 14.0884Z",
    fill: "#8BC34A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0611 8.79981C21.5392 9.28096 21.5368 10.0586 21.0557 10.5368L12.2299 19.3074C11.5097 20.023 10.3464 20.0212 9.62852 19.3033L7.20261 16.8774C6.72296 16.3978 6.72296 15.6201 7.20261 15.1405C7.68225 14.6608 8.45991 14.6608 8.93956 15.1405L10.9326 17.1335L19.3242 8.79436C19.8053 8.31623 20.583 8.31866 21.0611 8.79981Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.8f4b67c32e3e6432e7b6f1467c1249cd.svg";
export { ForwardRef as ReactComponent };